import React from "react";
import { Alert, Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { useStaffPermissions } from "../hooks/useStaffPermissions";

/**
 * SuperAdminLayout — contenedor de las rutas /superadmin/*.
 *
 * NO monta navegación propia: el panel reutiliza el shell de la app
 * (`src/app/layout/AppLayout.js`) — misma navbar con el logo y el menú de
 * usuario (que ya trae "Cerrar sesión") y la misma sidebar colapsable. Las
 * secciones del panel las aporta `../navItems.js`, filtradas por rol de staff.
 *
 * Lo único que queda aquí es el aviso para un staff sin ningún grupo asignado,
 * que de otro modo vería un panel vacío sin explicación.
 */
function SuperAdminLayout() {
  const { hasNoStaffRole } = useStaffPermissions();

  if (hasNoStaffRole) {
    // is_staff=true sin grupo de Django: el backend responde 403 en cada
    // recurso, así que no tiene sentido renderizar ninguna página.
    return (
      <Container fluid className="py-4">
        <Alert variant="warning">
          Tu cuenta tiene acceso al panel pero{" "}
          <strong>ningún rol de staff asignado</strong>. Pide a un administrador
          de plataforma que te asigne uno para poder ver la información.
        </Alert>
      </Container>
    );
  }

  return <Outlet />;
}

export { SuperAdminLayout };
